<cds-modal size="sm" [open]="dealDeletionModalOpen">
	<cds-modal-header>
		<h3 cdsModalHeaderHeading>
			Delete Fund
		</h3>
	</cds-modal-header>
	<section cdsModalContent [hasForm]="true">
		<h1 cdsModalContentText class="cds--modal-content__regular-content modal-text">
			Are you sure you want to delete {{dealPendingDeletion}}?
		</h1>
	</section>
	<cds-modal-footer>
		<button class="cds--btn cds--btn--secondary" (click)="this.syncService.updateDealDeletionModalOpen(false)">
			Cancel
		</button>
		<button class="cds--btn cds--btn--danger" (click)="deleteDeal()">
			Delete
		</button>
	</cds-modal-footer>
</cds-modal>
